import { Container, Row } from 'react-bootstrap';

import usePontosVenda from '../../../hooks/usePontosVenda';

import PontoVenda from './PontoVenda';

export default function Stand({ infoJson }) {
  const pontosVenda = usePontosVenda();

  // console.log("1", infoJson);
  // console.log("pontosVenda", pontosVenda);
  return (
    <Container fluid="xxxl">
      <Row>
        {pontosVenda.map((item, index) => {
          return (
            <PontoVenda
              key={item.CodPontoVenda}
              index={index}
              item={item}
              infoJson={infoJson}
              pontosVenda={pontosVenda}
            />
          );
        })}
      </Row>
    </Container>
  );
}
